import React from 'react';
import { LockIcon, ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './Section';
import { featuredPlacement, listing } from '../../../data/reportPhilly';
// Your listing composited onto a real publisher scene, square-cornered to fit
// the document layout. Cabernet-branded.
export function FeaturedOnline() {
  return <section data-id="element-641" data-mp="2trezwmuaf3ji">
      <SectionHeading eyebrow="Live on the web" title="Your listing, featured online" description="Your home ran as featured advertising across premium, high-traffic publishers — not just a real-estate portal." data-id="element-642" data-mp="2tqn4pd4lr7tr" />
      <figure className="overflow-hidden border border-border bg-card shadow-sm" data-id="element-643" data-mp="3hikfr2089vtt">
        {/* browser chrome */}
        <div className="flex items-center gap-3 border-b border-border bg-muted/60 px-4 py-3" data-id="element-644" data-mp="3ck96asduhnc4">
          <div className="flex gap-1.5" data-id="element-645" data-mp="1n5cg8x1b4w1u">
            <span className="size-3 rounded-full bg-red-400" data-id="element-646" data-mp="1n6du199pjwn9" />
            <span className="size-3 rounded-full bg-amber-400" data-id="element-647" data-mp="1i6hze0mwhhkd" />
            <span className="size-3 rounded-full bg-emerald-400" data-id="element-648" data-mp="2z45d310vsk3r" />
          </div>
          <div className="flex flex-1 items-center gap-2 border border-border bg-background px-3 py-1.5 text-xs text-muted-foreground" data-id="element-649" data-mp="2z22evtpkrkny">
            <LockIcon className="size-3" data-id="element-650" data-mp="384bj61u92hsw" />
            {featuredPlacement.publisherUrl}
          </div>
        </div>

        <div className="relative bg-bhhs-cab" data-id="element-651" data-mp="3cw3dmngj17ob">
          <img src={featuredPlacement.siteImage} alt={`${featuredPlacement.publisher} homepage`} className="h-72 w-full object-cover sm:h-80" data-id="element-652" data-mp="3hud96z65yaag" />
          <div className="report-scrim absolute inset-x-0 top-0 h-36 bg-gradient-to-b from-black/65 via-black/20 to-transparent" data-id="element-653" data-mp="3mvatbhaqheel" />

          {/* publisher masthead */}
          <div className="absolute left-5 top-5 text-white [text-shadow:0_1px_10px_rgba(0,0,0,0.7)]" data-id="element-654" data-mp="3vtmfn74khq18">
            <p className="font-display text-2xl font-semibold tracking-tight" data-id="element-655" data-mp="1xg4dnzh2chz5">
              {featuredPlacement.publisher}
            </p>
            <p className="text-xs uppercase tracking-[0.2em] text-white/80" data-id="element-656" data-mp="34r0uy0w00hds">
              {featuredPlacement.category}
            </p>
          </div>

          {/* embedded ad */}
          <div className="absolute bottom-5 right-5 w-64 overflow-hidden border border-white/15 bg-bhhs-cab text-white shadow-2xl sm:w-72" data-id="element-657" data-mp="2zuaironbe5xn">
            <div className="relative" data-id="element-658" data-mp="39pvpu178pwe9">
              <img src={featuredPlacement.listingImage} alt={listing.address} className="aspect-[16/9] w-full object-cover" data-id="element-659" data-mp="39ou492sllria" />
              <span className="absolute left-2 top-2 bg-black/50 px-1.5 py-0.5 text-[9px] font-medium uppercase tracking-wide text-white" data-id="element-660" data-mp="3iqad363rllke">
                Ad
              </span>
            </div>
            <div className="p-4" data-id="element-661" data-mp="3sh522i8eaz9j">
              <p className="font-display whitespace-nowrap text-lg font-semibold" data-id="element-662" data-mp="3sizdn5xs1f0y">
                {featuredPlacement.adHeadline}
              </p>
              <p className="mt-0.5 text-xs text-white/70" data-id="element-663" data-mp="5cylau7y1is6">
                {featuredPlacement.adBody}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 bg-white px-3 py-1.5 text-xs font-semibold text-bhhs-cab" data-id="element-664" data-mp="oy8kmudjcdmh">
                {featuredPlacement.adCta} <ArrowRightIcon className="size-3" data-id="element-665" data-mp="fxk6lzo56d9l" />
              </span>
            </div>
          </div>
        </div>
        <figcaption className="flex items-center justify-between border-t border-border bg-card px-5 py-2.5 text-[11px] text-muted-foreground" data-id="element-666" data-mp="jxkvyfcs48vf">
          <span data-id="element-667" data-mp="654p13grbqp8">Representative placement on a premium publisher</span>
          <span data-id="element-668" data-mp="ayppd25towrl">Display ad · Sidebar</span>
        </figcaption>
      </figure>
    </section>;
}